export enum ApplicationId {
    BuyiqSamplePage = 2,
    BuyiqScanPage = 3
}

export const applicationName = 'buyiq';
